// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const nationalLineHaulActions = {
  GET_NETWORK_STATE: 'GET_NETWORK_STATE',
  GET_NETWORK_STATE_CHANGE: 'GET_NETWORK_STATE_CHANGE'
};

export const getNetworkStateAction = (obj: Object) => ({
  type: nationalLineHaulActions.GET_NETWORK_STATE,
  payload: obj
});

export const getNetworkStateChangeAction = (obj: Object) => ({
  type: nationalLineHaulActions.GET_NETWORK_STATE_CHANGE,
  payload: obj
});

export const getNetworkState = () => dispatch => {
  dispatch(
    getNetworkStateAction({
      fetching: true,
      fetched: false,
      data: null
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'networkDashboard',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getNetworkStateAction({
            fetched: true,
            fetching: false,
            data: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getNetworkStateAction({
            fetched: true,
            fetching: false,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getNetworkStateAction({
          fetched: true,
          fetching: false,
          data: null
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res, this.state);
    },
    catchCb: res => {
      dispatch(
        getNetworkStateAction({
          fetched: true,
          fetching: false,
          data: null
        })
      );
      toastr.error('Exception', 'Exception in fetching network state details', {
        timeout: 3000
      });
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };

  return makeApiCall(requestObj);
};

export const getNetworkStateOnStatusChange = (obj, action) => dispatch => {
  dispatch(
    getNetworkStateChangeAction({
      fetching: true,
      fetched: false,
      rowData: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'networkDagActions',
    method: 'PUT',
    pathVariables: [{ key: '{configId}', val: obj.configId }],
    params: { action: (obj.action && obj.action.toUpperCase()) || action },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getNetworkStateChangeAction({
            fetched: true,
            fetching: false,
            rowData: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getNetworkStateChangeAction({
            fetched: true,
            fetching: false,
            rowData: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getNetworkStateChangeAction({
          fetched: true,
          fetching: false,
          rowData: null
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res, this.state);
    },
    catchCb: res => {
      dispatch(
        getNetworkStateChangeAction({
          fetched: true,
          fetching: false,
          rowData: null
        })
      );
      toastr.error(
        'Exception',
        'Exception in fetching updated network state details',
        {
          timeout: 3000
        }
      );
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };

  return makeApiCall(requestObj);
};
